import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ICreateNewsInput } from "models/news";
import createNewsValidator from "validators/broadcast/createNews.validator";
import { sendNewsApi } from "api/broadcast";
import { useNotificationContext } from "contexts/NotificationContext";
import { useNavigate } from "react-router-dom";
import { RouteName } from "constants/route";
import { RcFile } from "antd/es/upload";
import { uploadNewsApi } from "api/upload";

export default function useCreateNews() {
  const { showError, showSuccess } = useNotificationContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const { control, handleSubmit } = useForm<ICreateNewsInput>({
    resolver: yupResolver(createNewsValidator),
  });

  const onSubmit = async (input: ICreateNewsInput) => {
    setLoading(true);
    
    let imageUrl = "";
    if (input.image && Array.isArray(input.image) && input.image.length > 0) {
      const file = input.image[0];
      imageUrl = file.url || file.response?.data?.url || file.response?.url || "";
    }
    
    input.image = imageUrl;

    console.log("📰 Creating news with data:", {
      title: input.title,
      has_image: !!input.image,
      content_length: input.content?.length,
    });

    const { data, error } = await sendNewsApi(input);
    if (data) {
      console.log("✅ News created API response:", data);
      console.log("⚠️ Note: Creating news does NOT broadcast - use 'New Broadcast' to send to drivers/passengers");
      showSuccess("News created successfully");
      navigate(RouteName.NEWS, { replace: true });
    } else {
      console.error("❌ News create API error:", error);
      showError(error!.message);
    }
    setLoading(false);
  };

  const handleUpload = async (file: RcFile) => {
    const { data, error } = await uploadNewsApi(file);
    if (data && data.data) {
      return data.data.url;
    } else showError(`Error while uploading image: ${error?.message}`);
  };

  return { handleSubmit, handleUpload, onSubmit, control, loading };
}
